import React from 'react'
import PropTypes from 'prop-types'

import { useRecoilValue } from 'recoil'

import PerfectScrollbar from 'react-perfect-scrollbar'

import styled from '@emotion/styled'

import {
  modalBeeContentDialogState,
  selectedContentsEntriesState
} from '../recoil/state'
import {
  IMG_SPACE_EQUAL,
  IMG_SPACE_SMALL,
  IMG_POS_TOP,
  IMG_POS_LEFT,
  IMG_POS_RIGHT
} from '../constants'

import ContentsPreviewItem from './ContentsPreviewItem'

import IconImage from 'mailup-web-components/src/img/icons/image.svg?raw'

import svgload from 'Helpers/svgload'

const PreviewContainer = styled.div`
  flex-grow: 1;
  padding: 20px 30px;
  background-color: var(--wild-sand);
  height: 300px;
  margin-right: -30px;

  .scrollbar-container {
    &.ps {
      padding-right: 30px;
    }

    & .ps__rail-y {
      margin-right: 5px;
    }
  }
`

const PreviewGrid = styled.ul`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  padding-left: 2px;
`

const PreviewGridSlot = styled.li`
  border: 2px solid var(--boulder);
  background-color: #fff;
  position: relative;
  height: 120px;
  max-width: 100%;
  margin-bottom: 10px;
  margin-left: -2px;

  display: flex;
  justify-content: center;

  flex: 0 1 ${({ contentsPerRow }) => 100 / contentsPerRow}%;

  ${({ imgPos, contentsPerRow }) =>
    imgPos === IMG_POS_TOP && contentsPerRow === 1
      ? `
      color: var(--boulder);
      background-image: ${svgload(IconImage, { path: { fill: '#7c7c7c' } })};
      background-size: 28px 28px;
      background-repeat: no-repeat;
      background-position: center 8px;
      `
      : ``}

  ${({ imgPos, contentsPerRow }) =>
    imgPos === IMG_POS_LEFT &&
    contentsPerRow === 1 &&
    `

    &::before {
      display: inline-block;
      content: '';
      order: 1;

      background-image: ${svgload(IconImage, { path: { fill: '#7c7c7c' } })};
      background-size: 28px 28px;
      background-repeat: no-repeat;
      background-position: center;
    }
  `}

  ${({ imgPos, contentsPerRow }) =>
    imgPos === IMG_POS_RIGHT &&
    contentsPerRow === 1 &&
    `

    &::after {
      display: inline-block;
      content: '';
      order: 2;

      background-image: ${svgload(IconImage, { path: { fill: '#7c7c7c' } })};
      background-size: 28px 28px;
      background-repeat: no-repeat;
      background-position: center;
    }
  `}

  ${({ imgSpace, imgPos }) =>
    imgSpace === IMG_SPACE_SMALL &&
    imgPos === IMG_POS_LEFT &&
    `
      &::before {
        flex: 0 0 33%;
      }
    `}

  ${({ imgSpace, imgPos }) =>
    imgSpace === IMG_SPACE_SMALL &&
    imgPos === IMG_POS_RIGHT &&
    `
      &::after {
        flex: 0 0 33%;
      }
    `}

  ${({ imgSpace, imgPos }) =>
    imgSpace === IMG_SPACE_EQUAL &&
    imgPos === IMG_POS_LEFT &&
    `
      &::before {
        flex: 0 0 50%;
      }
    `}

  ${({ imgSpace, imgPos }) =>
    imgSpace === IMG_SPACE_EQUAL &&
    imgPos === IMG_POS_RIGHT &&
    `
      &::after {
        flex: 0 0 50%;
      }
    `}

    
`

const PreviewPosition = styled.div`
  line-height: 7rem;
  font-size: 22px;
  color: var(--boulder);

  ${({ imgPos }) => (imgPos === IMG_POS_LEFT ? `order: 2;` : `order: 1;`)}

  ${({ imgPos }) =>
    imgPos === IMG_POS_LEFT
      ? `border-left: 2px solid var(--boulder);`
      : imgPos === IMG_POS_RIGHT
      ? `border-right: 2px solid var(--boulder);`
      : ``}

  ${({ imgSpace }) =>
    imgSpace === IMG_SPACE_SMALL ? `flex: 0 0 67%;` : `flex: 0 0 50%;`}
`

const ContentsPreview = () => {
  const { contentsPerRow, imgPos, imgSpace } = useRecoilValue(
    modalBeeContentDialogState
  )

  const entries = useRecoilValue(selectedContentsEntriesState)

  return (
    <PreviewContainer>
      <PerfectScrollbar>
        <PreviewGrid>
          {entries.map(([position, content]) => (
            <PreviewGridSlot
              key={`content-preview-${position}-alt`}
              contentsPerRow={contentsPerRow}
              imgPos={imgPos}
              imgSpace={imgSpace}
            >
              <PreviewPosition
                contentsPerRow={contentsPerRow}
                imgPos={imgPos}
                imgSpace={imgSpace}
              >
                {position}
              </PreviewPosition>
              <ContentsPreviewItem {...content} position={position} />
            </PreviewGridSlot>
          ))}
        </PreviewGrid>
      </PerfectScrollbar>
    </PreviewContainer>
  )
}

export default ContentsPreview
